import React, {Component} from 'react'
import {Button, Col, Modal, Popconfirm, Row} from 'antd'
import ClaimItemsForm from './ClaimItemsForm'

class ClaimItemModal extends Component {
  render() {
    const {
      visibleClaimItem,
      onCancelClaimItem,
      formItemRef,
      modalItemType,
      submitClaimItem,
      submitting,
      removeClaimItem,
      removingClaimItems,
      updateClaimItem,
      claimItem,
      claim,
    } = this.props

    return (
      <Modal
        title={'Claim Item'}
        visible={visibleClaimItem}
        destroyOnClose={true}
        onCancel={onCancelClaimItem}
        width={'95%'}
        footer={
          claim.status !== 'Confirmed' ? (
            <Row>
              <Col span={24} style={{textAlign: 'right'}}>
                {modalItemType === 'edit' && (
                  <Popconfirm
                    title="Are you sure remove this Claim Item?"
                    onConfirm={() => removeClaimItem(claimItem.key)}
                    okText="Yes"
                    cancelText="No">
                    <Button
                      type="danger"
                      loading={removingClaimItems}
                      style={{marginLeft: 8}}>
                      Remove
                    </Button>
                  </Popconfirm>
                )}
                <Button
                  loading={submitting}
                  type="primary"
                  onClick={
                    modalItemType !== 'edit'
                      ? submitClaimItem
                      : () => updateClaimItem(claimItem.key)
                  }>
                  {modalItemType === 'edit' ? 'Update' : 'Submit'}
                </Button>
              </Col>
            </Row>
          ) : null
        }>
        <ClaimItemsForm ref={formItemRef} {...this.props} />
      </Modal>
    )
  }
}

ClaimItemModal.propTypes = {}
ClaimItemModal.defaultProps = {}

export default ClaimItemModal
